import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authRoutesAPI } from "../../services/api";
import LoadingSpinner from "../LoadingSpinner";
export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [authChecked, setAuthChecked] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const location = useLocation();

    useEffect(() => {
        authRoutesAPI.getAll()
            .then(() => {
                setIsAuthenticated(true);
                setAuthChecked(true);
            })
            .catch(() => {
                setIsAuthenticated(false);
                setAuthChecked(true);
            });
    }, []);

    if (!authChecked) {
        return <div className="py-8 text-center text-lg">{<LoadingSpinner />}</div>
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};
